import { z } from 'zod'
import type { TClass, TExhibitorWithEntries } from '@schemas'

export const entryFormSchema = z.object({
  divisionId: z.string().min(1, 'Select a division'),
  classId: z.string().min(1, 'Select a class'),
  notes: z.string().optional(),
})

export type EntryFormValues = z.infer<typeof entryFormSchema>

export type DivisionOption = {
  id: string
  name: string
  classes: TClass[]
}

export type ExhibitorEntrySummary = NonNullable<TExhibitorWithEntries['entries']>[number]

/** A class the selected entrant already holds an active entry in, saved or queued on this device. */
export type EnteredClass = { entryCode: string; pending: boolean }
